import { createContentPropTypes } from '../../../../helpers/content';

const content = {
	titleNoAuth: 'Payment Submitted',
	titleAuthReq: 'Payment submitted for authorisation',
	descriptionNoAuth:
		'Your payment has now been submitted and sent to Bacs for processing. You can see more information about your payment below.',
	descriptionAuthReq:
		'Your payment has now been submitted and is awaiting authorisation. You can see more information about your payment below.',
	goToYourAccountButton: 'Go to your account',
	makeAnotherPaymentButton: 'Make another payment or transfer',
	hardTokenAuthButton: 'Continue to authorise',
	sidebarTitle: 'Authorisation required',
	sidebarBodyThirdPartyAuth:
		'This payment is awaiting authorisation by {authoriserName}. Remember that Bacs payments must be authorised by 5.10pm to meet your planned submission and settlement dates.',
	paymentFailedTitle: 'Payment failed',
	getAuthorisedRequiredBodyContent: {
		sidebarBodyHardToken:
			'Please continue to the ‘Payment status and history’ screen to provide authorisation. Remember that Bacs payments must be authorised by 5.10pm to meet your planned submission and collection dates.',
		sidebarBodySoftToken:
			'Please log in to your mobile banking app to provide authorisation. Remember that Bacs payments must be authorised by 5.10pm to meet your planned submission and settlement dates',
		fileUploadFirstInstruction: 'This uploaded batch payment will need authorised in two stages.',
		fileUploadSecondInstruction: '1. Internet banking',
		fileUploadThirdInstruction: 'Review and confirm the payment details are correct.',
		fileUploadFourthInstruction: '2. Mobile banking app',
		fileUploadFifthInstruction: 'Log in to your mobile banking app to provide final authorisation.',
		fileUploadReviewButton: 'Review and confirm',
		fileUploadTwoStepInstructionHeading: 'Two-step authorisation required',
	},
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
